/* eslint-ignore */
// @ts-nocheck
import React, { useEffect, useState } from 'react';

import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import { postConfirmEmail } from '~/services/firstAccessServices';

import { useFirstAccess } from '../../../../../hooks/useFirstAccess';

import {
  Container,
  Title,
  Text,
  ButtonNext,
  ButtonBack,
  ButtonText,
  ButtonsWrap,
  StepsInfoWrap,
  StepsInfoTitle,
  StepsInfoText,
  StepTextHighLight,
} from './styles';

function Validation({
  email: emailParam,
  token,
  userId,
  activeStep,
  setActiveStep,
}) {
  const { email } = useFirstAccess();

  const [showBackButton, setShowBackButton] = useState(true);
  const [showResponseValidate, setShowResponseValidate] = useState(false);
  const [errorValidation, setErrorValidation] = useState(false);

  useEffect(() => {
    async function validateConfirm() {
      const response = await postConfirmEmail(userId, token);
      setErrorValidation(!response);
      setShowResponseValidate(true);
    }
    if (emailParam && token && userId) {
      setShowBackButton(false);
      validateConfirm();
    }
  }, [emailParam, token, userId]);

  return (
    <Container>
      <Title>Validação</Title>
      <Text>Para validar seu acesso, siga os passos listados abaixo.</Text>
      <StepsInfoWrap>
        <StepsInfoTitle>Passo 1 - Link de autenticação</StepsInfoTitle>
        <StepsInfoText>
          Verifique o link de autenticação que enviamos para o e-mail
          <StepTextHighLight>{email || emailParam}</StepTextHighLight>.
        </StepsInfoText>
      </StepsInfoWrap>
      <StepsInfoWrap>
        <StepsInfoTitle>Passo 2 - Validação das informações</StepsInfoTitle>
        <StepsInfoText>
          Após clicar no link de autenticação, aguarde até receber a confirmação
          de que as suas informações foram validadas com sucesso.
        </StepsInfoText>
      </StepsInfoWrap>
      <StepsInfoWrap>
        <StepsInfoTitle>Passo 3 - Conclusão</StepsInfoTitle>
        <StepsInfoText>
          Após a confirmação de que as informações foram validadas, clique em{' '}
          <StepTextHighLight>"continuar"</StepTextHighLight>.
        </StepsInfoText>
      </StepsInfoWrap>
      <StepsInfoWrap>
        <StepsInfoTitle>Fique atento!</StepsInfoTitle>
        <StepsInfoText>
          O link gerado tem validade de{' '}
          <StepTextHighLight>6 horas</StepTextHighLight>. Caso não consiga
          prosseguir com o cadastro, será necessário gerar uma nova validação.
        </StepsInfoText>
      </StepsInfoWrap>
      {errorValidation && showResponseValidate && (
        <StepsInfoWrap>
          <StepsInfoTitle>Atenção!</StepsInfoTitle>
          <StepsInfoText>
            <StepTextHighLight>
              Ocorreu um erro em sua validação, tente novamente.
            </StepTextHighLight>
          </StepsInfoText>
        </StepsInfoWrap>
      )}
      {!errorValidation && showResponseValidate && (
        <StepsInfoWrap>
          <StepsInfoTitle>Sucesso!</StepsInfoTitle>
          <StepsInfoText>
            <StepTextHighLight>E-mail validado com sucesso!</StepTextHighLight>
          </StepsInfoText>
        </StepsInfoWrap>
      )}

      <ButtonsWrap>
        <ButtonNext
          buttonType="primary"
          iconRight={AiOutlineArrowRight}
          onClick={() => setActiveStep(activeStep + 1)}
          buttonType={
            !errorValidation && showResponseValidate ? '' : 'disabled'
          }
          disabled={!(!errorValidation && showResponseValidate)}
        >          
          Continuar          
        </ButtonNext>
        {showBackButton && (
          <ButtonBack
            buttonType="outline"
            iconLeft={AiOutlineArrowLeft}
            onClick={() => setActiveStep(activeStep - 1)}
          >
            <ButtonText>
              Voltar
            </ButtonText>
          </ButtonBack>
        )}
      </ButtonsWrap>
    </Container>
  );
}

export default Validation;
